import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No lending backend exists in this
// environment: the health-factor gauge, collateral breakdown, and repayment schedule were
// previously fabricated. See context/page_pipeline/BOARD.md wave 4 and
// context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryLendingPositionPage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Lending", href: "/treasury/lending" }], label: "Position Detail" }}
      state={{
        title: "Position detail is not available in this environment yet",
        description: "Lending position detail, including health factor, collateral breakdown, and repayment schedule, has no backend in this environment yet.",
      }}
    />
  );
}
